import { render, staticRenderFns } from "./communicationDashboardNews.vue?vue&type=template&id=4f3e634d&scoped=true"
import script from "./communicationDashboardNews.vue?vue&type=script&lang=js"
export * from "./communicationDashboardNews.vue?vue&type=script&lang=js"
import style0 from "./communicationDashboardNews.vue?vue&type=style&index=0&id=4f3e634d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3e634d",
  null
  
)

export default component.exports